import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useBlockClick } from 'library/hooks/useBlockClick';
import { Area } from 'library/models/Area';
import Authorize from 'main/auth/Authorize';

const buttonSx = {
	m: 1,
	ml: 0,
	mr: 0,
	pl: 0,
	pr: 0,
	textTransform: 'none',
	justifyContent: 'left',
	fontSize: 20,
};

const HomeLink = ({
	to,
	href,
	label,
	icon,
	area,
	onLinkClick,
}: {
	to?: string;
	href?: string;
	label: string | ReactNode;
	icon?: ReactNode;
	area?: Area;
	onLinkClick?: () => void;
}): React.JSX.Element => {
	const { disabled, handleClick } = useBlockClick();

	const handleButtonClick = () => {
		onLinkClick?.();
		handleClick();
	};

	const button = to ? (
		<Button
			className="appsContainer__app"
			component={Link}
			to={to}
			sx={buttonSx}
			variant="text"
			color="primary"
			startIcon={
				!disabled ? (
					icon
				) : (
					<CircularProgress size="1em" color="inherit" />
				)
			}
			disabled={disabled}
			onClick={handleButtonClick}>
			{label}
		</Button>
	) : (
		<Button
			className="appsContainer__app"
			href={href}
			sx={buttonSx}
			variant="text"
			color="primary"
			startIcon={
				!disabled ? (
					icon
				) : (
					<CircularProgress size="1em" color="inherit" />
				)
			}
			disabled={disabled}
			onClick={handleButtonClick}>
			{label}
		</Button>
	);

	return (
		<>
			{area ? (
				<Authorize
					area={area}
					redirectWhenNotAuthorized={false}
					displayIntermediatePages={false}>
					{button}
				</Authorize>
			) : (
				button
			)}
		</>
	);
};

export default HomeLink;
